import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class lists so later classes win over earlier ones even when
 * they collide (`p-2` + `p-4` => `p-4`). Every component takes a `className`
 * and funnels it through here, so callers can always override.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
